import string from 'string-sanitizer';

export const getURLparam = (param) => {
  const queryParameters = new URLSearchParams(window.location.search);
  return queryParameters.get(string.sanitize(param));
};
